export default __webpack_public_path__ + "static/media/Level7.b4875c84.svg";